import { Theme, css } from '@emotion/react'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const title = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyTwo};
`

export const subtitle = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
`

export const rows = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 4px 0;
`

export const row = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 12px;
  background: ${theme.backgrounds.backgroundThree};
`

export const countAndLink = css`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const count = (theme: Theme) => css`
  font-weight: 600;
  min-width: 24px;
  text-align: right;
  color: ${theme.typographyColors.typographyTwo};
`

export const link = (theme: Theme) => css`
  color: ${theme.palette.primary.main};
  text-decoration: none;
  font-size: 13px;

  &:hover {
    text-decoration: underline;
  }
`
